/**
 * Landing top-nav + bottom-dock frost.
 * Overlay sheets (SearchResults, stacked pickers) reuse this so content
 * underneath stays faintly visible through the glass.
 */
import type { SxProps, Theme } from '@mui/material/styles';

export function landingChromeGlassSx(darkMode = true): SxProps<Theme> {
  return {
    bgcolor: darkMode ? 'rgba(15,23,42,0.38)' : 'rgba(255,255,255,0.42)',
    backgroundImage: darkMode
      ? 'linear-gradient(180deg, rgba(148,163,184,0.12), rgba(15,23,42,0.08))'
      : 'linear-gradient(180deg, rgba(255,255,255,0.55), rgba(255,255,255,0.22))',
    backdropFilter: 'blur(22px) saturate(1.35)',
    WebkitBackdropFilter: 'blur(22px) saturate(1.35)',
    boxShadow: darkMode
      ? '0 10px 28px rgba(0,0,0,0.22), inset 0 1px 0 rgba(255,255,255,0.08)'
      : '0 10px 28px rgba(15,23,42,0.06), inset 0 1px 0 rgba(255,255,255,0.7)',
  };
}

export function landingChromeBackdropSx(
  darkMode = true,
  opts?: { fillAlpha?: number; blurPx?: number },
): SxProps<Theme> {
  const fillAlpha = opts?.fillAlpha ?? 0.38;
  const lightAlpha = opts?.fillAlpha != null ? Math.min(opts.fillAlpha + 0.04, 0.5) : 0.42;
  const blurPx = opts?.blurPx ?? 22;
  const wash = opts?.fillAlpha != null ? Math.min(opts.fillAlpha * 0.45, 0.08) : 0.12;
  return {
    backgroundColor: darkMode ? `rgba(15,23,42,${fillAlpha})` : `rgba(255,255,255,${lightAlpha})`,
    backgroundImage: darkMode
      ? `linear-gradient(180deg, rgba(148,163,184,${wash}), rgba(15,23,42,0.04))`
      : 'linear-gradient(180deg, rgba(255,255,255,0.55), rgba(255,255,255,0.22))',
    backdropFilter: `blur(${blurPx}px) saturate(1.35)`,
    WebkitBackdropFilter: `blur(${blurPx}px) saturate(1.35)`,
  };
}

/** Sticky wizard stepper — frost hides scrolling cards sliding up under the rail. */
export function stickyChromeFrostSx(darkMode = true): SxProps<Theme> {
  return {
    position: 'sticky',
    top: 0,
    zIndex: 6,
    ...landingChromeBackdropSx(darkMode, { fillAlpha: 0.86, blurPx: 22 }),
  };
}
